import React from "react";
import { useState, useEffect } from "react";
import top from '../assets/images/analy/codebeamer/1.jpg';
import Beamer from '../assets/images/codebeamer-black.png';

import wifi from '@images/analy/codebeamer/icon-wifi.svg';
import eachother from '@images/analy/codebeamer/icon-eachother.svg';
import calendar from '@images/analy/codebeamer/icon-calendar.svg';
import searchfile from '@images/analy/codebeamer/icon-searchfile.svg';
import time from '@images/analy/codebeamer/icon-time.svg';
import visualize from '@images/analy/codebeamer/icon-visualize.svg';

import demand from '@images/analy/codebeamer/2.jpg';
import risks from '@images/analy/codebeamer/3.jpg';
import testing from '@images/analy/codebeamer/4.jpg';
import product from '@images/analy/codebeamer/5.jpg';
import maintenance  from '@images/analy/codebeamer/6.jpg';
import development from '@images/analy/codebeamer/7.jpg';


import BeamerNew from "../components/beamerNew";
import Slider from "react-slick";
import loading from "@images/loading.png";

import { getProCodeBeamer } from "../utils";
import "../assets/css/product/codebeamer.css";

const CodeBeamer = () => {
  const [beamerList, setBeamerList] = useState([]);
  const [beamerLoad, setBeamerLoad] = useState("");
  const [winUrlSplit, setWinUrlSplit] = useState('');

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  useEffect(() => {
    const winUrl = window.location.href;
    const winUrlSplit = winUrl.split('/')[3];
    setWinUrlSplit(winUrlSplit)
  }, [window.location])

  useEffect(() => {
    setBeamerLoad(false);
    getProCodeBeamer()
      .then((res) => {
        setBeamerList(res.Data);
      })
      .finally(() => {
        setBeamerLoad(true);
      });
  }, []);
  return (
    <div className='beamer-creator-div'>
      <div className="flex">
        <div className="pro">
          {beamerLoad ? (
            <Slider {...settings}>
              {beamerList.map((item, i) => {
                const urlPro = item.LinkNewsFullUrl;
                const urles = `?type=${winUrlSplit.slice(0, -6)}`;
                console.log(urles);
                return (
                  <div key={i}>
                    <a href={urlPro+urles} target={"_blank"} rel="noreferrer">
                      <div className="analycar_text">
                        <div className="analycar_text_box">
                          <p className="analycar_text_desc">
                            <span className="analycar_text_title">
                              {item.AdvTitle}
                            </span>
                            {item.AdvDesc}
                          </p>
                        </div>
                      </div>
                    </a>
                    <img src={item.AdvImageFullUrl} className="beamer_big" alt="" />
                  </div>
                );
              })}
            </Slider>
          ) : (
            <div className="pro_car_loading">
              <img src={loading} alt="" />
              <p>加载中...</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex">
        <div className="beamer_text">
          <img src={Beamer} className="pro_analyimg" alt="" />
          <div className="pro-beamer">熠格是PTC产品销售和技术合作伙伴</div>
          <p className="beamer-href">
            <a style={{ marginRight: '10px', color: '#000000' }} href="https://www.ptc.com/cn/products/codebeamer" target="_blank" rel="noreferrer">
              官网直达
            </a>
          </p>
        </div>
      </div>
      <div className="beamer-long-text">
        <div className="beamer-long-center">
          <div className="beamer_center">
            <div className="beamer_logo">
              <div className="beamer-background">
                <div className="beamer-right">
                  <div className="beamer-right-text">
                    <h1>Codebeamer：大规模简化复杂的产品和软件工程</h1>
                    <p>
                      Codebeamer 是用于高级产品和软件开发的 ALM 平台。这款开放式平台通过产品线配置功能扩展了 ALM 功能，并为复杂流程提供独特的可配置性。
                    </p>
                    <p>
                      Codebeamer 通过产品线配置功能扩展了 ALM，并为复杂流程提供独特的可配置性。它提供了数字工作流，可提高协同开发和监管合规性支持的效率，并可与其他 PTC 产品集成以连接到工程数字主线。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="beamer-Details">
        <div className="detaild-icon">
          <div className="item">
            <div className="code-icon"><img src={wifi} alt="Icon" /></div>
            <div className="text">
              <h4>现代、集成、互联</h4>
              <p>Codebeamer 直观且现代化的用户界面能够提供出色的用户体验。它能够与现代软件工程工具链无缝集成。开发团队通常选择 Codebeamer 来取代他们的传统工具链。</p>
            </div>
          </div>
          <div className="item">
            <div className="code-icon"><img src={eachother} alt="Icon" /></div>
            <div className="text">
              <h4>无缝集成</h4>
              <p>通过开箱即用且基于标准的集成，将您分散的软件工程工具环境与中央开发平台连接起来。减少隐藏成本和创建集成所需的繁琐手动工作。</p>
            </div>
          </div>
          <div className="item">
            <div className="code-icon"><img src={calendar} alt="Icon" /></div>
            <div className="text">
              <h4>完整敏捷开发功能</h4>
              <p>规划、跟踪和管理敏捷开发。利用规划器、看板 (KanBan)、卡纸板、现金板、待办事项表和发布系统，保持有条不紊。Codebeamer 能够编排和控制 CI/CD 管线（例如 Jenkins、Azure Pipeline）。</p>
            </div>
          </div>
          <div className="item">
            <div className="code-icon"><img src={searchfile} alt="Icon" /></div>
            <div className="text">
              <h4>端到端可追溯能力</h4>
              <p>在从需求阶段一直到测试和发布的整个软件工程生命周期内提升端到端可追溯能力。Codebeamer 的集中式数据存储库能够确保全面追溯所有工作项。Codebeamer 还使用 OSLC 技术集成了 PTC 工程数字主线。</p>
            </div>
          </div>
          <div className="item">
            <div className="code-icon"><img src={time} alt="Icon" /></div>
            <div className="text">
              <h4>速度和可预测性</h4>
              <p>借助系统体系方法，在需求、设计、测试和软件（包括跟踪）方面，实现强有力的战略性重用、模块化设计和产品线工程设计。</p>
            </div>
          </div>
          <div className="item">
            <div className="code-icon"><img src={visualize} alt="Icon" /></div>
            <div className="text">
              <h4>开箱即用的模板</h4>
              <p>使用预定义的模板立即开始工作。迅速跟上节奏，根据您的需求调整我们的模板，并专注于即时交付价值。</p>
            </div>
          </div>
        </div>
      </div>
      <div className="beamer-long-content">
        <div className="first-content">
          <div className="content-top">
           <h1>解决方案</h1>
          </div>
          <div className="Details">
            <div>
              <h1>需求管理</h1>
              <div className="dividing-line"></div>
              <p>
                面向在需求管理中需要提升可追溯能力、透明度和高效协同能力的工程师。
                使用 Codebeamer 识别、管理和跟踪整个软件工程生命周期内的需求、事迹和用户故事。
              </p>
            </div>
            <img src={demand} className="details-img" alt="" />
          </div>
        </div>
        <div className="second-content">
          <div className="Details">
            <img src={risks} className="details-img" alt="" />
            <div>
              <h1>软件风险管理</h1>
              <div className="dividing-line"></div>
              <p>
                将软件风险管理集成到软件开发生命周期中，以获得安全可靠的产品。分析和记录风险活动以提高效率并遵守法规。
              </p>
            </div>
          </div>
        </div>
        <div className="second-content">
          <div className="Details">
            <div>
              <h1>测试管理</h1>
              <div className="dividing-line"></div>
              <p>
                面向旨在通过测试建立对其软件解决方案的信心的质量团队。借助 Codebeamer 降低质量成本，并将您对产品质量的承诺付诸行动。
              </p>
            </div>
            <img src={testing} className="details-img" alt="" />
          </div>
        </div>
        <div className="second-content">
          <div className="Details">
            <img src={product} className="details-img" alt="" />
            <div>
              <h1>产品变形能力管理</h1>
              <div className="dividing-line"></div>
              <p>
                面向希望在产品线工程设计中提升效率的开发团队。减少返工、缩短发布周期以及降低产品验证的成本。借助 Codebeamer 针对相应市场开发合适的产品变型。
              </p>
            </div>
          </div>
        </div>
        <div className="second-content">
          <div className="Details">
            <div>
              <h1>开发运维</h1>
              <div className="dividing-line"></div>
              <p>
                面向希望增强一致性和简化产品交付的开发运维团队。依靠 Codebeamer 的内置集成和数据共享功能，减少第三方集成和 IT 服务的隐藏成本。
              </p>
            </div>
            <img src={maintenance} className="details-img" alt="" />
          </div>
        </div>
        <div className="second-content">
          <div className="Details">
            <img src={development} className="details-img" alt="" />
            <div>
              <h1>软件开发</h1>
              <div className="dividing-line"></div>
              <p>
                面向希望提升其技术产品的质量的软件团队和管理人员。Codebeamer 全面集成了开发功能，能够打破孤岛，并提供从需求一直到代码、测试和发布的可追溯能力。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex" style={{ marginTop: '50px' }}>
        <div className="pro_new_tittle">
          <h1>最新消息</h1>
        </div>
        <BeamerNew />
      </div>
    </div>
  );
};

export default CodeBeamer;
